import {html} from "@isceco/widget-library2/external/lit";
import WebComponent from "../../WebComponent";
import Navigation from "../Navigation/Navigation";
import VerordnungColumns from "./VerordnungColumns";
import VerordnungDto from "./VerordnungDto";
import VerordnungService from "./VerordnungService";
import BerechtigteListService from "../../services/BerechtigteListService";

import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/List/List.js'
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup.js'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'

export default class Verordnung extends WebComponent {

  constructor() {
    super()
    this.verordnungService = new VerordnungService()
  }

  get translationFile() {
    return './views/Verordnung/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.verordnungService.getBackendListUrl(),
      this.verordnungService.listArt(),
      this.verordnungService.listStatus()])
      .then(([url, artList, statusList]) => {
        this.url = url
        this.artList = artList.map(art => ({value: art, name: this.i18n.translate('art.' + art.toLowerCase())}))
        this.statusList = statusList.map(status => ({
          value: status,
          name: this.i18n.translate('status.' + status.toLowerCase())
        }))
        this.render()
      }).catch(_ => {
      this.url = ''
      this.artList = []
      this.statusList = []
      this.render()
    })
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('verordnung.uebersicht.title')}">
        <isceco-button size="small" icon="plus" variant="primary"
                       text="${this.i18n.translate('verordnung.create.button')}"
                       @click="${() => navigate({to: Navigation.ROUTES.verordnungCreate.url, allow: true})}"
        ></isceco-button>
      </isceco-title>
      <isceco-filter-group>
        <isceco-multiselect-filter label="${this.i18n.translate('verordnung.table.header.art')}"
                                   key="art"
                                   .items="${this.artList}"
        ></isceco-multiselect-filter>
        <isceco-multiselect-filter label="${this.i18n.translate('verordnung.table.header.status')}"
                                   key="status"
                                   .items="${this.statusList}"
        ></isceco-multiselect-filter>
      </isceco-filter-group>
      <isceco-list url="${this.url}"
                   .listService="${BerechtigteListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toDTO}"
                   .columns="${VerordnungColumns.getColumns()}"
                   .rowurl="${this.toDetailUrl}"
                   sort="srNummer" order="desc"
      ></isceco-list>
    `
  }

  toDTO = row => new VerordnungDto(row)
  toDetailUrl = row => constructURL({to: Navigation.ROUTES.verordnungDetail.url, id: row.id})
}
customElements.define('eko-frontend-verordnung', Verordnung)
